import Config from "src/engine/const/Config";
// import Http from "src/lib/http/Http";
import IUIItem from "src/engine/interface/IUIItem";
import UIManifest from "src/engine/ui/UIManifest";
import { message } from "antd";
import Utils from "src/lib/utils/Utils";
import UIIconFont from "src/components/UIIconFont";
import JsonCenter from "src/component/props/PropsExpend/JsonCenter";

/**
 *
 *
 * @class PublicUIMgr
 */
class PublicUIMgr {
    public static PublicServer = "publicui";

    public static GameId = "0";

    public static UIManager = "uimanager";

    public static UITemp = "uitemp";

    public static Logic = "logic";

    public static LogicList: any[];

    private mPages: any = null;

    static maps: { [key: string]: IUIItem[] } = {};

    gameId: string;

    server: string;

    constructor(server: string = PublicUIMgr.PublicServer, gameId: string = PublicUIMgr.GameId) {
        this.server = server;
        this.gameId = gameId;
        // setTimeout(this.init, 5000);
        this.syncIcons();
    }

    // @AutoBind
    // init() {
    //     //触发icon获取
    //     this.syncIcons();
    //     //获取所有组件列表
    //     this.getItem("pages").then((data: any) => {
    //         try {
    //             this.mPages = typeof data === "string" ? JSON.parse(data) : data;
    //             // console.log("[PublicUIMgr]:", this.mPages);
    //             const { pages = [] } = this.mPages.props;
    //             pages.map((item: IUIItem) => {
    //                 this.getItem(item.info.ename).then((page: any) => {
    //                     const pageInfo = (typeof page === "string" ? JSON.parse(page) : page).page;
    //                     const { content = [], _preview, sources, stores, module, children, modals, _compType } = pageInfo.props;
    //                     if (content.length > 0) {
    //                         // if (_preview) content[0]._preview = _preview;
    //                         if (_preview) UIManifest.uiImages[`${content[0].ui}_${item.info.ename}`] = _preview;
    //                         content[0].info = item.info;
    //                         if (sources) content[0].props._sources = sources;
    //                         if (module) content[0].props._module = module;
    //                         if (modals) content[0].props._modals = modals;
    //                         if (stores) content[0].props._stores = stores;
    //                         if (children) PublicUIMgr.maps[item.info.ename] = children;
    //                         if (_compType) content[0].props._compType = _compType;
    //                         UIManifest.register(content[0], UIManifest.Type.Public);
    //                     }
    //                 });
    //             });
    //         } catch (error) {
    //             // console.log("[PublicUIMgr]:", error);
    //         }
    //     });
    // }

    syncIcons() {
        if (UIIconFont.manifestInit) return;
        UIIconFont.manifestInit = true;
        this.getItem("pages", PublicUIMgr.UIManager).then((data: any) => {
            try {
                data = typeof data === "string" ? JSON.parse(data) : data;
                const pages = data.props.pages;
                pages.map((uiItem: IUIItem) => {
                    if (uiItem.props._preview) UIIconFont.manifest[uiItem.info.ename] = uiItem.props._preview;
                });
            } catch (error) {
                console.log("[PublicUIMgr]:syncIcons", error);
            }
        });
    }

    syncLogic(callback: any) {
        if (PublicUIMgr.LogicList) {
            setTimeout(() => {
                callback(PublicUIMgr.LogicList);
            });
            return;
        }
        this.getItem("pages", PublicUIMgr.Logic).then((data: any) => {
            try {
                data = typeof data === "string" ? JSON.parse(data) : data;
                const pages = data.props.pages;
                const list: any[] = [];
                pages.map((uiItem: IUIItem) => {
                    const { content = [] } = uiItem.props;
                    if (!content[0]) return;
                    const item = content[0];
                    item.info = uiItem.info;
                    item.props._preview = uiItem.props._preview;
                    list.push(item);
                    // if (uiItem.props._preview) UIIconFont.manifest[uiItem.info.ename] = uiItem.props._preview;
                });
                PublicUIMgr.LogicList = list;
                callback(PublicUIMgr.LogicList);
                // console.log("[PublicUIMgr]:", data, UIIconFont.manifest);
            } catch (error) {
                console.log("[PublicUIMgr]:", error);
            }
        });
    }

    sync(uiItem: any, execSource: any, sources: IUIItem[] = [], module: IUIItem[] = [], other: any = {}) {
        // message.info("开始同步公共组件");
        return this.getItem("pages").then((data: any) => {
            try {
                this.mPages = typeof data === "string" ? JSON.parse(data) : data;
                const { pages = [] } = this.mPages.props;
                UIManifest.register(Utils.deepClone(uiItem) as IUIItem, UIManifest.Type.Public);
                pages.push({ info: uiItem.info, props: {}, ui: "PCPage", _id: 1 });

                execSource(
                    "uiPublish",
                    {
                        gameId: this.gameId,
                        server: this.server,
                        dGameId: this.gameId,
                        files: [
                            {
                                path: `src/pages.json`,
                                c: JSON.stringify(this.mPages),
                            },
                            {
                                path: `src/${uiItem.info.ename}.json`,
                                c: JSON.stringify({
                                    type: "pageInit",
                                    page: { info: uiItem.info, props: { content: [uiItem], sources, module, ...other }, ui: "PCPage", _id: 1 },
                                }),
                            },
                        ],
                    },
                    (flag: any) => {
                        if (!flag) {
                            message.error("同步公共组件失败！");
                        } else {
                            message.success("同步公共组件成功！！");
                        }
                    }
                );
            } catch (error) {
                console.log("[PublicUIMgr]:errrrr", error);
            }
        });
    }

    getItem(ui: string, server: string = this.server) {
        // return Http.ajaxJson({ url: Config.getConfig(server, this.gameId, ui) + `?time=${new Date().valueOf()}` });
        return new Promise((resolve, reject) => {
            JsonCenter.Instance.ajax(
                Config.getConfig(server, this.gameId, ui),
                (data: any, CODE: number) => {
                    if (CODE === 200) resolve(data);
                },
                false
            );
        });
    }
}

export default PublicUIMgr;
